// extracted by mini-css-extract-plugin
module.exports = {"open":"SlideUpFooter-open-dlMTo","closed":"SlideUpFooter-closed-riMu6"};